/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

// ----------------------------------------------------------------------

import RouterPointPayPublic from 'src/routes/sections/router-pointpay-public';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import ThemeProvider from 'src/theme';

import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsProvider } from 'src/components/settings';
import { PublicPaymentConnectivityBoundary } from 'src/pointpay-public/components/public-payment-connectivity-boundary';
import NiceModal from '@ebay/nice-modal-react';
import { LocalizationProvider } from 'src/locales';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { NotificationFeatureProvider } from 'src/features/notifications';

// ----------------------------------------------------------------------

export default function AppPointPayPublic() {
  const charAt = `
██████   ██████  ██ ███    ██ ████████ ██████   █████  ██    ██
██   ██ ██    ██ ██ ████   ██    ██    ██   ██ ██   ██  ██  ██
██████  ██    ██ ██ ██ ██  ██    ██    ██████  ███████   ████
██      ██    ██ ██ ██  ██ ██    ██    ██      ██   ██    ██
██       ██████  ██ ██   ████    ██    ██      ██   ██    ██
`;

  console.info(`%c${charAt}`, 'color: #5BE49B');
  console.info('PointCraft - PointPay Public');

  useScrollToTop();

  return (
    <LocalizationProvider>
      <NotificationFeatureProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light',
            themeDirection: 'ltr',
            themeContrast: 'default',
            themeLayout: 'horizontal',
            themeColorPresets: 'default',
            themeStretch: true,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <NiceModal.Provider>
                <SnackbarProvider>
                  <ProgressBar />
                  <PublicPaymentConnectivityBoundary>
                    <RouterPointPayPublic />
                  </PublicPaymentConnectivityBoundary>
                </SnackbarProvider>
              </NiceModal.Provider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </NotificationFeatureProvider>
    </LocalizationProvider>
  );
}
